import { render, staticRenderFns } from "./AutoArchiveInformation.vue?vue&type=template&id=2095269f"
import script from "./AutoArchiveInformation.vue?vue&type=script&lang=js"
export * from "./AutoArchiveInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports